<template lang="pug">
    .background()
        <videos />
        <particles />    
    </div>
</template>
<script>
import videos from '@/components/videos.vue'
import particles from '@/components/particles.vue'
export default {
  components: {
    videos,
    particles
  }
}
</script>



// WEBPACK FOOTER //
// src/components/background.vue